/*
 * File: c:\Users\l.haddad\AutoFiFront\src\Content\Home\HomeBanner\HomeBanner.tsx
 * Project: c:\Users\l.haddad\AutoFiFront
 * Created Date: Tuesday May 13th 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Tuesday May 13th 2025 4:24:22 pm
 * Modified By: the developer formerly known as Tommy Boisseau at <t.boisseau@autobuy.fr>
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import styles from "Content/Home/HomeBanner/HomeBanner.module.css";

function HomeBanner(_: any) {

    return (
        <div className={`${styles.homeBanner}`}>
            <a href="https://agences.abeille-assurances.fr/mazeres/" target="_blank">
                <img className={`${styles.homeBannerImg}`} src={'/abeille_assurance.jpg'} alt='HomeBanner' />
            </a>
        </div>
    );
}

export default HomeBanner;
